// extracted by mini-css-extract-plugin
module.exports = {"container":"DropdownSelect_container__2ldqs"};